import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess/acls.pb';
import { hasSchemaACL } from '@frontend/auth-helpers';

/**
 * Returns the subset of `locationIds` the user has access to per the JWT ACL (`hasSchemaACL` checks the
 * per-location ACL for the given `permission`, e.g. email marketing vs bulk texting).
 */
export const getAccessibleLocationIds = (locationIds: string[], permission: Permission): Set<string> =>
  new Set(locationIds.filter((id) => hasSchemaACL(id, permission)));
